import React from "react";
import * as styles from "./component.module.scss";
import Button, { IButtonData } from "../Button";

const HeroTitle = ({
  subTitle,
  buttons,
  children,
}: {
  children?: React.ReactNode;
  subTitle?: React.ReactNode;
  buttons?: (React.ReactNode | IButtonData)[];
}) => {
  return (
    <div className={styles.main}>
      <div className={styles.wrapper}>
        <div className={styles.title}>{children}</div>
        <div className={styles.subTitle}>{subTitle}</div>
        <div className={styles.buttonsTrack}>
          {buttons?.map((button) => Button.getButtonFromDataOrNode(button))}
        </div>
      </div>
    </div>
  );
};

export default HeroTitle;
